module.exports = __webpack_public_path__ + "static/media/intro-img.f70abac8.svg";